import React, {Component} from 'react';
import SingleCategoryItem from './singleCategoryItem';

import _ from 'lodash';

class SingleCategoryPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    }
  }

  componentDidMount(){
    if(this.state.loading){
      this.setState({
        loading: false
      });
    }
  }

  render(){
    if(this.state.loading){
      return( <div className="looding">
          <div className="boxLoding">
              <div id="loading" />
          </div>
        </div>
      )
    }

    let flowerData = null;
    if (!_.isEmpty(this.props.flowerData)) {
      flowerData = _.map(this.props.flowerData, (singlecategory, index) => {
          return (
            <SingleCategoryItem
              key={index}
              dynamicClass="col-md-3 col-sm-6 col-xs-12"
              info={singlecategory}
              catename={this.props.catename} />)
          }
      );
    }

    return(
      <div className="SingleCategoryPanel">

    <div id="catagoryPanelCaption"><h1>{`${this.props.catename}`}{this.props.subcatname && <br/>}{this.props.subcatname && this.props.subcatname}</h1></div>
        <div className="SingleCatagoryContainer row">
          {flowerData}
        </div>
      </div>
    );
  }
}

export default SingleCategoryPanel;



// WEBPACK FOOTER //
// ./src/components/singleCategory/singleCategoryPanel.js